(function () {
    'use strict';

    // Global configuration constants

    // Maximum character length for truncated text in archive views
    var nkTruncateMaxLength = 140;

    // Debounce delay for search input (in milliseconds)
    var doneTypingInterval = 1000;

    /**
     * Truncates text content in archive grid items to maintain consistent layout
     * Adds ellipsis (...) to text exceeding the maximum length
     */
    function nkTruncateTextItemArchive() {
      var textItems = document.querySelectorAll(".text-item-archive");
      textItems.forEach(function (textItem, index) {
        var text = textItem.textContent;
        if (text.length > nkTruncateMaxLength) {
          var truncatedText = text.substring(0, nkTruncateMaxLength) + '...';
          textItem.textContent = truncatedText;
        }
      });
    }

    /**
     * Animates element opacity from one value to another
     * @param {HTMLElement} element - Element to animate
     * @param {number} from - Starting opacity (0-1)
     * @param {number} to - Target opacity (0-1)
     * @param {number} duration - Animation duration in milliseconds
     */

    /**
     * Ensures all carousel slides have equal height based on the tallest slide
     * Prevents layout shifts when transitioning between slides
     */
    function normalizeSlideHeights() {
      $('.carousel').each(function () {
        var items = $('.carousel-item > .container > .row', this);

        // Reset heights to calculate natural height
        items.css('min-height', 0);

        // Find maximum height among all slides
        var maxHeight = Math.max.apply(null, items.map(function () {
          return $(this).outerHeight();
        }).get());

        // Apply maximum height to all slides
        items.css('min-height', maxHeight + 'px');
      });
    }

    // Module-level variables
    var toTop;
    var resyncLimit = 0;

    /**
     * Initializes navigation functionality including:
     * - Sticky header behavior
     * - Scroll-to-top button
     * - Desktop/mobile navigation overlays
     */
    function initNavigation() {
      toTop = $("#toTop");

      // Handle scroll behavior for sticky navigation and back-to-top button
      window.onscroll = function (e) {
        // Periodically resync ScrollReveal animations (currently disabled)
        if (parseInt(this.scrollY / 1500) !== resyncLimit) {
          //ScrollReveal().sync();
          resyncLimit = parseInt(this.scrollY / 1500);
        }
        if (this.scrollY > 125) {
          // Show back-to-top button
          toTop.css({
            "pointer-events": "auto",
            "opacity": "0.8"
          });

          // Sticky navigation with scroll direction detection
          if (this.oldScroll > this.scrollY) {
            // Scrolling up - show navigation
            $("header").addClass("fixed").addClass("scrollup").removeClass("scrolldown").removeClass("neartop");
          } else {
            // Scrolling down - hide navigation
            $("header").addClass("fixed").addClass("scrolldown").removeClass("scrollup").removeClass("neartop");
          }
        } else {
          // Hide back-to-top button when near top
          toTop.css({
            "pointer-events": "none",
            "opacity": "0"
          });

          // Reset navigation to default state when at top of page
          $("header").removeClass("fixed").removeClass("scrollup").removeClass("scrolldown").removeClass("neartop");
        }
        this.oldScroll = this.scrollY;
      };

      // Scroll to top with smooth animation
      $(document).on("click", "#toTop", function () {
        $([document.documentElement, document.body]).animate({
          scrollTop: 0
        }, 1000);
        toTop.css({
          "pointer-events": "none",
          "opacity": "0"
        });
      });

      // Smooth scrolling for anchor links
      $(document).on("click", ".smoothScroll", function (e) {
        e.preventDefault();
        var anchor = $(this).attr("href");
        $([document.documentElement, document.body]).animate({
          scrollTop: $(anchor).offset().top
        }, 1000);
      });

      // Open desktop navigation overlay
      $(document).on("click", ".openNav", function (e) {
        e.preventDefault();
        $("body").css({
          "overflow": "auto",
          "padding-right": "0"
        });
        var openNav = $(this).attr("data-openNav");
        var $this = $(".main-nav-overlay-background .openNav[data-openNav='" + openNav + "']");

        // Deactivate all navigation items
        $(".main-nav-overlay-background .openNav").each(function () {
          $(this).removeClass("active");
        });

        // Activate clicked navigation item
        $this.addClass("active");

        // Show overlay background
        $(".main-nav-overlay-background").css({
          "width": "100%",
          "opacity": "1"
        });

        // Hide all navigation overlays
        $(".main-nav-overlay").each(function () {
          $(this).css("transform", "translate(0, -100%)");
          $(this).css("pointer-events", "none");
          $(this).css("opacity", "0");
        });

        // Show selected navigation overlay
        var id = $(this).attr("data-openNav");
        $("#" + id).css("transform", "translate(0, 0)");
        $("#" + id).css("pointer-events", "auto");
        $("#" + id).css("opacity", "1");

        // Prevent body scroll and compensate for scrollbar
        $("body").css({
          "overflow-y": "hidden",
          "padding-right": $(window).outerWidth() - $("body").prop("clientWidth") + "px"
        });
      });

      // Close desktop navigation overlay
      $(document).on("click", ".closeNav", function (e) {
        e.preventDefault();

        // Hide overlay background
        $(".main-nav-overlay-background").css({
          "width": "0%",
          "opacity": "0"
        });

        // Hide all navigation overlays
        $(".main-nav-overlay").each(function () {
          $(this).css("transform", "translate(0, -100%)");
          $(this).css("pointer-events", "none");
          $(this).css("opacity", "0");
        });

        // Restore body scroll
        $("body").css({
          "overflow": "auto",
          "padding-right": "0"
        });
      });

      // Open mobile navigation
      $(document).on("click", ".openMobileNav", function (e) {
        e.preventDefault();

        // Show mobile navigation overlay
        $(".mobile-nav-overlay-background").css({
          "width": "100%",
          "opacity": "1"
        });
        $(".mobile-nav-overlay").css("width", "100%");
        $(".mobile-nav-overlay").css("opacity", "1");

        // Prevent body scroll on mobile
        $("body").css({
          "position": "fixed",
          "overflow": "hidden"
        });
      });

      // Close mobile navigation
      $(document).on("click", ".closeMobileNav", function (e) {
        e.preventDefault();

        // Hide mobile navigation overlay
        $(".mobile-nav-overlay-background").css({
          "width": "0%",
          "opacity": "0"
        });
        $(".mobile-nav-overlay").css("width", "0%");
        $(".mobile-nav-overlay").css("opacity", "0");

        // Restore body scroll
        $("body").css({
          "position": "relative",
          "overflow": "auto"
        });
      });

      // Toggle mobile navigation dropdown items
      $(document).on("click", ".toggle-mobile-nav-point", function (e) {
        e.preventDefault();
        var $this = $(this);
        var navpoint = $this.attr("data-nav-point");
        var $navpoint = $(".mobile-nav-point[data-nav-point='" + navpoint + "']");

        // Close all other dropdown items
        $(".mobile-nav-point").not("[data-nav-point='" + navpoint + "']").each(function () {
          $(this).removeClass("open");
        });

        // Toggle clicked dropdown item
        if ($navpoint.hasClass("open")) {
          $navpoint.removeClass("open");
        } else {
          $navpoint.addClass("open");
        }
      });
    }

    /**
     * Initializes global search functionality
     * Handles both Enter key and button click for search submission
     */
    function initSearch() {
      // Handle search on Enter key press
      $(".inputsearch #navsearch").on("keyup", function search(e) {
        if (e.keyCode === 13) {
          e.preventDefault();
          var term = $(this).val();
          if (term !== "") {
            // Redirect to search results page with search term
            var url = ajaxurl + "?s=" + term;
            window.location.href = url;
          }
        }
      });

      // Handle search on button click
      $(".inputsearch button").on("click", function (e) {
        e.preventDefault();
        var $navsearch = $(this).siblings("input");
        var term = $navsearch.val();
        if (term !== "") {
          // Redirect to search results page with search term
          var url = ajaxurl + "?s=" + term;
          window.location.href = url;
        }
      });
    }

    /**
     * Base filter UI functionality
     * Handles filter dropdown toggling for desktop and mobile views
     */
    function initBaseFilter() {
      // Toggle filter dropdowns on desktop
      $(document).on("click", ".open-filter", function (e) {
        e.preventDefault();
        var $this = $(this);
        var filtertype = $this.attr("data-filter");

        // Close all other filter dropdowns
        $(".open-filter").not($this).each(function () {
          $(this).removeClass("active");
          var otherfiltertype = $(this).attr("data-filter");
          $(".filter-" + otherfiltertype).removeClass("active");
        });

        // Toggle the clicked filter dropdown
        if ($this.hasClass("active")) {
          $this.removeClass("active");
          $(".filter-" + filtertype).removeClass("active");
        } else {
          $this.addClass("active");
          $(".filter-" + filtertype).addClass("active");
        }
      });

      // Toggle all filters visibility on mobile
      $(document).on("click", ".open-mobile-filter", function (e) {
        e.preventDefault();
        var $this = $(this);
        if ($this.hasClass("open")) {
          // Hide all filters
          $this.removeClass("open");
          $(".filter-wrapper").each(function () {
            $(this).removeClass("active");
          });
        } else {
          // Show all filters
          $this.addClass("open");
          $(".filter-wrapper").each(function () {
            $(this).addClass("active");
          });
        }
      });
    }

    // Team Filter
    function reloadTeamGrid() {
      $('.filter-bar--loading').css('opacity', '1');
      $('#filter_team,.team-member-tiles').addClass('is-loading');
      var formdata = new FormData($("#filter_team")[0]);
      formdata.append('action', 'filter_team');
      var term = "?term=" + $("#filter_search").val();
      var departments = "&departments=";
      $("#filter_team .filter-standort input[type='checkbox']:checked").each(function () {
        departments = departments + $(this).val() + ",";
      });
      departments = departments.replace(/,\s*$/, "");
      var legal_fields = "&legal_fields=";
      $("#filter_team .filter-fields_of_law input[type='checkbox']:checked").each(function () {
        legal_fields = legal_fields + $(this).val() + ",";
      });
      legal_fields = legal_fields.replace(/,\s*$/, "");
      var position = "&position=";
      $("#filter_team .filter-position input[type='checkbox']:checked").each(function () {
        position = position + $(this).val() + ",";
      });
      position = position.replace(/,\s*$/, "");
      var urlPath = term + departments + legal_fields + position;
      window.history.pushState("", "", urlPath);
      $.ajax({
        type: 'POST',
        url: root_url_data.ajax,
        data: formdata,
        cache: false,
        processData: false,
        contentType: false,
        success: function success(res) {
          $('.team-member-tiles').html(res);
          ScrollReveal().reveal('.team-member-tiles .scrollreveal');
          $('.filter-bar--loading').css('opacity', '0');
          $('#filter_team, .team-member-tiles').removeClass('is-loading');
        }
      });
    }

    // Publikationen Filter
    function reloadPublikationenGrid() {
      var formdata = new FormData($("#filter_publikationen")[0]);
      formdata.append('action', 'filter_publikationen');
      var term = "?term=" + $("#filter_search").val();
      var cat = "&pcat=";
      $("#filter_publikationen .filter-kategorie input[type='checkbox']:checked").each(function () {
        cat = cat + $(this).val() + ",";
      });
      cat = cat.replace(/,\s*$/, "");
      var urlPath = term + cat;
      window.history.pushState("", "", urlPath);
      $.ajax({
        type: 'POST',
        url: root_url_data.ajax,
        data: formdata,
        cache: false,
        processData: false,
        contentType: false,
        success: function success(res) {
          $('.publikationen-tiles').html(res);
          ScrollReveal().reveal('.scrollreveal');
        }
      });
    }

    // News Filter
    var reloadNewsGridPage = 1;
    var reloadNewsGridUrlPath = "";
    var reloadNewsGridisLoading = false;
    function reloadNewsGrid() {
      var postsPerPage = 12;
      if (reloadNewsGridisLoading) return;
      reloadNewsGridisLoading = true;
      var term = "?term=" + $("#filter_search").val();
      var cat = "&ncat=";
      $("#filter_news .filter-kategorie input[type='checkbox']:checked").each(function () {
        cat = cat + $(this).val() + ",";
      });
      cat = cat.replace(/,\s*$/, "");
      var urlPath = term + cat;
      if (urlPath != reloadNewsGridUrlPath) reloadNewsGridPage = 1;
      reloadNewsGridUrlPath = urlPath;
      var formdata = new FormData($("#filter_news")[0]);
      formdata.append('action', 'filter_news');
      formdata.append('page', reloadNewsGridPage);
      formdata.append('postsPerPage', postsPerPage);
      window.history.pushState("", "", urlPath);
      console.log(' News Filter data:', formdata);
      //alert(reloadNewsGridPage);
      $.ajax({
        type: 'POST',
        url: root_url_data.ajax,
        data: formdata,
        cache: false,
        processData: false,
        contentType: false,
        success: function success(res) {
          reloadNewsGridisLoading = false;
          $('#load-more-posts').hide();
          if (res.length > 0) {
            if (reloadNewsGridPage == 1) $('.news-tiles').html(res);else $('.news-tiles').append(res);
            nkTruncateTextItemArchive();
            ScrollReveal().reveal('.news-tiles .scrollreveal');
            reloadNewsGridPage++;
            $('#load-more-news').removeClass('d-none');
            $('#load-more-news').show();
          } else {
            $('#load-more-news').hide();
          }
        },
        error: function error(jqXHR, xhr, _error) {
          //alert(request.responseText);
          console.log('reloadNewsGrid error:', _error, jqXHR);
          reloadNewsGridisLoading = false;
        }
      });
    }

    // Events Filter
    function reloadEventsGrid() {
      var formdata = new FormData($("#filter_events")[0]);
      formdata.append('action', 'filter_events');
      var term = "?term=" + $("#filter_search").val();
      var cat = "&evcat=";
      $("#filter_events .filter-kategorie input[type='checkbox']:checked").each(function () {
        cat = cat + $(this).val() + ",";
      });
      cat = cat.replace(/,\s*$/, "");
      var urlPath = term + cat;
      window.history.pushState("", "", urlPath);
      $.ajax({
        type: 'POST',
        url: root_url_data.ajax,
        data: formdata,
        cache: false,
        processData: false,
        contentType: false,
        success: function success(res) {
          $('.events-tiles').html(res);
          ScrollReveal().reveal('.events-tiles .scrollreveal');
        }
      });
    }

    // Downloads Filter
    function reloadDownloadsGrid() {
      var formdata = new FormData($("#filter_downloads")[0]);
      formdata.append('action', 'filter_downloads');
      var selected = "";
      $(".downloads-tiles .selection-check:checked").each(function () {
        selected += $(this).val() + ",";
      });
      selected = selected.replace(/,\s*$/, "");
      formdata.append('selected', selected);
      var term = "?term=" + $("#filter_search").val();
      var cat = "&dlcat=";
      $("#filter_downloads .filter-kategorie input[type='checkbox']:checked").each(function () {
        cat = cat + $(this).val() + ",";
      });
      cat = cat.replace(/,\s*$/, "");
      var urlPath = term + cat;
      window.history.pushState("", "", urlPath);
      $.ajax({
        type: 'POST',
        url: root_url_data.ajax,
        data: formdata,
        cache: false,
        processData: false,
        contentType: false,
        success: function success(res) {
          $('.downloads-tiles').html(res);
          ScrollReveal().reveal('.downloads-tiles .scrollreveal');
        }
      });
    }

    // Stellenangebote Filter
    function reloadStellenangeboteGrid() {
      var formdata = new FormData($("#filter_stellenangebote")[0]);
      formdata.append('action', 'filter_stellenangebote');
      var term = "?term=" + $("#filter_search").val();
      var departments = "&departments=";
      $("#filter_stellenangebote .filter-standorte input[type='checkbox']:checked").each(function () {
        departments = departments + $(this).val() + ",";
      });
      departments = departments.replace(/,\s*$/, "");
      var cat = "&categorys=";
      $("#filter_stellenangebote .filter-kategorien input[type='checkbox']:checked").each(function () {
        cat = cat + $(this).val() + ",";
      });
      cat = cat.replace(/,\s*$/, "");
      var urlPath = term + departments + cat;
      window.history.pushState("", "", urlPath);
      $.ajax({
        type: 'POST',
        url: root_url_data.ajax,
        data: formdata,
        cache: false,
        processData: false,
        contentType: false,
        success: function success(res) {
          $('.stellenangebote-tiles').html(res);
          ScrollReveal().reveal('.stellenangebote-tiles .scrollreveal');
        }
      });
    }

    // BLOG Filter 2
    var reloadBlogGridPage = 1;
    var reloadBlogGridUrlData = "";
    var reloadBlogGridisLoading = false;
    var jCats = "";
    function reloadBlogGrid() {
      //let taxonomy;

      var postsPerPage = 12;
      if (reloadBlogGridisLoading) return;
      reloadBlogGridisLoading = true;
      var formdata = new FormData($("#filter_blog")[0]);
      formdata.append('action', 'filter_blog_2');
      formdata.append('postsPerPage', postsPerPage);
      var cats_array = [];
      var search_array = [];
      var parent_cats_array = [];
      $('.list_item_cat.active').each(function () {
        var cat_id = $(this).attr('data-cat-id');
        // taxonomy = $(this).attr('data-taxonomy');
        cats_array.push(cat_id);
      });
      $('.list_item_cat').each(function () {
        var cat_id = $(this).attr('data-cat-id');
        // taxonomy = $(this).attr('data-taxonomy');
        search_array.push(cat_id);
      });
      var term = "?term=" + $("#filter_search").val();
      var cat = "&ncat=";
      var cat_search = search_array;

      //console.log(cat_search);

      $("#remove-cat").html('<h1 class="title">ARQIS Blog</h1>').fadeIn();
      $("#filter_blog .filter-kategorie input[type='radio']:checked").each(function () {
        cat = cat + $(this).val() + ",";
        // cats_array.push($(this).val());
        var parent_ids = $('.collapse_' + $(this).val() + ' .list_item_cat').attr('data-parent-cat');
        if (typeof parent_ids != 'undefined' && !parent_cats_array.includes(parent_ids)) {
          parent_cats_array.push(parent_ids);
        }
      });
      if (cats_array.length === 0 && parent_cats_array.length === 0) {
        $('#kategorie_all').addClass('active');
      }
      if ($('#kategorie_all').hasClass('active')) {
        $('.list_item_cat').each(function () {
          var cat_id = $(this).attr('data-cat-id');
          var parent_ids = $(this).attr('data-parent-cat');
          cats_array.push(cat_id);
          if (!parent_cats_array.includes(parent_ids)) {
            parent_cats_array.push(parent_ids);
          }
        });
      }
      cat = cat.replace(/,\s*$/, "");
      formdata.append('kategorie', cat_search);
      formdata.append('data_categories', cats_array);
      formdata.append('data_parent_cats', parent_cats_array);
      var aCats = [term];
      aCats = aCats.concat(cat_search);
      aCats = aCats.concat(cats_array);
      aCats = aCats.concat(parent_cats_array);
      jCats = JSON.stringify(aCats);
      if (reloadBlogGridUrlData != "" && jCats != reloadBlogGridUrlData) reloadBlogGridPage = 1;
      reloadBlogGridUrlData = jCats;
      //console.log(jCats);
      console.log(reloadBlogGridPage);
      formdata.append('page', reloadBlogGridPage);
      $.ajax({
        type: 'POST',
        url: root_url_data.ajax,
        data: formdata,
        cache: false,
        processData: false,
        contentType: false,
        success: function success(res) {
          reloadBlogGridisLoading = false;
          //console.log(res);
          //$('.blog-load').empty();
          //$('.news-tiles').empty();
          if (reloadBlogGridPage == 1) $('.news-tiles').html(res);else $('.news-tiles').append(res);
          ScrollReveal().reveal('.news-tiles .scrollreveal');
          reloadBlogGridPage++;

          //$('#load-more-blog-posts').addClass('d-none');

          var nkTruncateMaxLength = 140;
          var textItems = document.querySelectorAll(".text-item-archive");
          textItems.forEach(function (textItem, index) {
            var text = textItem.textContent;
            if (text.length > nkTruncateMaxLength) {
              var truncatedText = text.substring(0, nkTruncateMaxLength) + '...';
              textItem.textContent = truncatedText;
            }
          });

          //$('#load-more-news').addClass('d-none');
          // Überprüfe, ob weitere Beiträge vorhanden sind
          if (res.length == 0) {
            $('#load-more-blog-posts').hide();
          } else {
            $('#load-more-blog-posts').show();
          }
        },
        error: function error(jqXHR, xhr, _error2) {
          //alert(request.responseText);
          console.log('reloadBlogGrid error:', _error2, jqXHR);
          reloadBlogGridisLoading = false;
        }
      });
    }

    // Podcast Filter
    function reloadPodcastGrid() {
      var formdata = new FormData($("#filter_podcast")[0]);
      formdata.append('action', 'filter_podcast');
      var term = "?term=" + $("#filter_search").val();
      var cat = "&pcat=";
      $("#filter_podcast .filter-kategorie input[type='checkbox']:checked").each(function () {
        cat = cat + $(this).val() + ",";
      });
      cat = cat.replace(/,\s*$/, "");
      var urlPath = term + cat;
      window.history.pushState("", "", urlPath);
      $.ajax({
        type: 'POST',
        url: root_url_data.ajax,
        data: formdata,
        cache: false,
        processData: false,
        contentType: false,
        success: function success(res) {
          $('.podcast-tiles').html(res);
          ScrollReveal().reveal('.podcast-tiles .scrollreveal');
        }
      });
    }

    // Funktion, um Beiträge nachzuladen
    function loadMorePosts() {
      if (reloadNewsGridPage == 1) {
        reloadNewsGridUrlPath = "";
        reloadNewsGridPage++;
      }
      return reloadNewsGrid(); // Loading more like that ain't needed.
    }

    // Funktion, um Blog nachzuladen
    function loadMoreBlogPosts() {
      if (reloadBlogGridPage == 1) {
        reloadBlogGridUrlData = "";
        reloadBlogGridPage++;
      }
      return reloadBlogGrid(); // Loading more like that ain't needed.
    }

    // Local typing timers for each filter
    var teamTypingTimer;
    var publikationenTypingTimer;
    var newsTypingTimer;
    var eventsTypingTimer;
    var downloadsTypingTimer;
    var stellenangeboteTypingTimer;
    var blogTypingTimer;
    var podcastTypingTimer;
    function initFilters() {
      // Team Filter
      $('#filter_team input[type="checkbox"]').on('change', function () {
        var $this = $(this);
        var val = $this.val();
        var type = $this.attr('data-type');
        var counter = "";

        // ALL SELECTED
        if (val === "") {
          $('#filter_team .filter-' + type + ' input[type="checkbox"]').not($this).each(function () {
            $(this).prop("checked", false);
          });
          $($this).prop("checked", true);
        } else {
          if ($this.prop("checked") === true) {
            $('#' + type).prop("checked", false);
            counter = "(" + $(".filter-" + type + " input:checked").length + ")";
          } else {
            var allchecked = true;
            $('#filter_team .filter-' + type + ' input[type="checkbox"]').not($('#' + type)).each(function () {
              if ($(this).prop("checked")) {
                allchecked = false;
              }
            });
            if (allchecked) {
              $('#' + type).prop("checked", true);
            } else {
              counter = "(" + $(".filter-" + type + " input:checked").length + ")";
            }
          }
        }
        $(".open-filter[data-filter='" + type + "'] .counter").html(counter);
        reloadTeamGrid();
      });

      // Team Filter
      $("#filter_team #filter_search").on("keyup", function search(e) {
        clearTimeout(teamTypingTimer);
        if (e.keyCode == 13) {
          e.preventDefault();
          reloadTeamGrid();
        } else {
          teamTypingTimer = setTimeout(reloadTeamGrid, doneTypingInterval);
        }
      });

      // Team Filter
      $("#filter_team .filter-search button").on("click", function (e) {
        e.preventDefault();
        reloadTeamGrid();
      });

      // Publikationen Filter
      $('#filter_publikationen input[type="checkbox"]').on('change', function () {
        var $this = $(this);
        var val = $this.val();
        var type = $this.attr('data-type');
        var counter = "";

        // ALL SELECTED
        if (val === "") {
          $('#filter_publikationen .filter-' + type + ' input[type="checkbox"]').not($this).each(function () {
            $(this).prop("checked", false);
          });
          $($this).prop("checked", true);
        } else {
          if ($this.prop("checked") === true) {
            $('#' + type).prop("checked", false);
            counter = "(" + $(".filter-" + type + " input:checked").length + ")";
          } else {
            var allchecked = true;
            $('#filter_publikationen .filter-' + type + ' input[type="checkbox"]').not($('#' + type)).each(function () {
              if ($(this).prop("checked")) {
                allchecked = false;
              }
            });
            if (allchecked) {
              $('#' + type).prop("checked", true);
            } else {
              counter = "(" + $(".filter-" + type + " input:checked").length + ")";
            }
          }
        }
        $(".open-filter[data-filter='" + type + "'] .counter").html(counter);
        reloadPublikationenGrid();
      });

      // Publikationen Filter
      $("#filter_publikationen #filter_search").on("keyup", function search(e) {
        clearTimeout(publikationenTypingTimer);
        if (e.keyCode == 13) {
          e.preventDefault();
          reloadPublikationenGrid();
        } else {
          publikationenTypingTimer = setTimeout(reloadPublikationenGrid, doneTypingInterval);
        }
      });

      // Publikationen Filter
      $("#filter_publikationen .filter-search button").on("click", function (e) {
        e.preventDefault();
        reloadPublikationenGrid();
      });

      // News Filter
      $('#filter_news input[type="checkbox"]').on('change', function () {
        var $this = $(this);
        var val = $this.val();
        var type = $this.attr('data-type');
        var counter = "";

        // ALL SELECTED
        if (val === "") {
          $('#filter_news .filter-' + type + ' input[type="checkbox"]').not($this).each(function () {
            $(this).prop("checked", false);
          });
          $($this).prop("checked", true);
        } else {
          if ($this.prop("checked") === true) {
            $('#' + type).prop("checked", false);
            counter = "(" + $(".filter-" + type + " input:checked").length + ")";
          } else {
            var allchecked = true;
            $('#filter_news .filter-' + type + ' input[type="checkbox"]').not($('#' + type)).each(function () {
              if ($(this).prop("checked")) {
                allchecked = false;
              }
            });
            if (allchecked) {
              $('#' + type).prop("checked", true);
            } else {
              counter = "(" + $(".filter-" + type + " input:checked").length + ")";
            }
          }
        }
        $(".open-filter[data-filter='" + type + "'] .counter").html(counter);
        $("#remove-cat").html('<h1 class="title">ARQIS News</h1>').fadeIn();
        reloadNewsGrid();
      });

      // News Filter
      $("#filter_news #filter_search").on("keyup", function search(e) {
        clearTimeout(newsTypingTimer);
        if (e.keyCode == 13) {
          e.preventDefault();
          reloadNewsGrid();
        } else {
          newsTypingTimer = setTimeout(reloadNewsGrid, doneTypingInterval);
        }
      });

      // News Filter
      $("#filter_news .filter-search button").on("click", function (e) {
        e.preventDefault();
        reloadNewsGrid();
      });

      // Downloads Filter
      $('#filter_downloads input[type="checkbox"]').on('change', function () {
        var $this = $(this);
        var val = $this.val();
        var type = $this.attr('data-type');
        var counter = "";

        // ALL SELECTED
        if (val === "") {
          $('#filter_downloads .filter-' + type + ' input[type="checkbox"]').not($this).each(function () {
            $(this).prop("checked", false);
          });
          $($this).prop("checked", true);
        } else {
          if ($this.prop("checked") === true) {
            $('#' + type).prop("checked", false);
            counter = "(" + $(".filter-" + type + " input:checked").length + ")";
          } else {
            var allchecked = true;
            $('#filter_downloads .filter-' + type + ' input[type="checkbox"]').not($('#' + type)).each(function () {
              if ($(this).prop("checked")) {
                allchecked = false;
              }
            });
            if (allchecked) {
              $('#' + type).prop("checked", true);
            } else {
              counter = "(" + $(".filter-" + type + " input:checked").length + ")";
            }
          }
        }
        $(".open-filter[data-filter='" + type + "'] .counter").html(counter);
        reloadDownloadsGrid();
      });

      // Downloads Filter
      $("#filter_downloads #filter_search").on("keyup", function search(e) {
        clearTimeout(downloadsTypingTimer);
        if (e.keyCode == 13) {
          e.preventDefault();
          reloadDownloadsGrid();
        } else {
          downloadsTypingTimer = setTimeout(reloadDownloadsGrid, doneTypingInterval);
        }
      });

      // Downloads Filter
      $("#filter_downloads .filter-search button").on("click", function (e) {
        e.preventDefault();
        reloadDownloadsGrid();
      });

      // Events Filter
      $('#filter_events input[type="checkbox"]').on('change', function () {
        var $this = $(this);
        var val = $this.val();
        var type = $this.attr('data-type');
        var counter = "";

        // ALL SELECTED
        if (val === "") {
          $('#filter_events .filter-' + type + ' input[type="checkbox"]').not($this).each(function () {
            $(this).prop("checked", false);
          });
          $($this).prop("checked", true);
        } else {
          if ($this.prop("checked") === true) {
            $('#' + type).prop("checked", false);
            counter = "(" + $(".filter-" + type + " input:checked").length + ")";
          } else {
            var allchecked = true;
            $('#filter_events .filter-' + type + ' input[type="checkbox"]').not($('#' + type)).each(function () {
              if ($(this).prop("checked")) {
                allchecked = false;
              }
            });
            if (allchecked) {
              $('#' + type).prop("checked", true);
            } else {
              counter = "(" + $(".filter-" + type + " input:checked").length + ")";
            }
          }
        }
        $(".open-filter[data-filter='" + type + "'] .counter").html(counter);
        reloadEventsGrid();
      });

      // Events Filter
      $("#filter_events #filter_search").on("keyup", function search(e) {
        clearTimeout(eventsTypingTimer);
        if (e.keyCode == 13) {
          e.preventDefault();
          reloadEventsGrid();
        } else {
          eventsTypingTimer = setTimeout(reloadEventsGrid, doneTypingInterval);
        }
      });

      // Events Filter
      $("#filter_events .filter-search button").on("click", function (e) {
        e.preventDefault();
        reloadEventsGrid();
      });

      // Stellenangebote Filter
      $('#filter_stellenangebote input[type="checkbox"]').on('change', function () {
        var $this = $(this);
        var val = $this.val();
        var type = $this.attr('data-type');
        var counter = "";

        // ALL SELECTED
        if (val === "") {
          $('#filter_stellenangebote .filter-' + type + ' input[type="checkbox"]').not($this).each(function () {
            $(this).prop("checked", false);
          });
          $($this).prop("checked", true);
        } else {
          if ($this.prop("checked") === true) {
            $('#' + type).prop("checked", false);
            counter = "(" + $(".filter-" + type + " input:checked").length + ")";
          } else {
            var allchecked = true;
            $('#filter_stellenangebote .filter-' + type + ' input[type="checkbox"]').not($('#' + type)).each(function () {
              if ($(this).prop("checked")) {
                allchecked = false;
              }
            });
            if (allchecked) {
              $('#' + type).prop("checked", true);
            } else {
              counter = "(" + $(".filter-" + type + " input:checked").length + ")";
            }
          }
        }
        $(".open-filter[data-filter='" + type + "'] .counter").html(counter);
        reloadStellenangeboteGrid();
      });

      // Stellenangebote Filter
      $("#filter_stellenangebote #filter_search").on("keyup", function search(e) {
        clearTimeout(stellenangeboteTypingTimer);
        if (e.keyCode == 13) {
          e.preventDefault();
          reloadStellenangeboteGrid();
        } else {
          stellenangeboteTypingTimer = setTimeout(reloadStellenangeboteGrid, doneTypingInterval);
        }
      });

      // Stellenangebote Filter
      $("#filter_stellenangebote .filter-search button").on("click", function (e) {
        e.preventDefault();
        reloadStellenangeboteGrid();
      });

      // BLOG Filter
      $('#filter_blog input[type="radio"]').on('change', function () {
        var $this = $(this);
        var val = $this.val();
        var type = $this.attr('data-type');
        var counter = "";

        // // ALL SELECTED
        if (val === "") {
          $('#filter_blog .filter-' + type + ' input[type="radio"]').not($this).each(function () {
            $(this).prop("checked", false);
          });
          $($this).prop("checked", true);
        } else {
          $("#kategorie_all").removeClass('active');
          $('#kategorie').prop('checked', false);
          if ($this.prop("checked") === true) {
            $('#' + type).prop("checked", false);
            counter = "(" + $(".filter-" + type + " input:checked").length + ")";
          } else {
            var allchecked = true;
            $('#filter_blog .filter-' + type + ' input[type="radio"]').not($('#' + type)).each(function () {
              if ($(this).prop("checked")) {
                allchecked = false;
              }
            });
            if (allchecked) {
              $('#' + type).prop("checked", true);
            } else {
              counter = "(" + $(".filter-" + type + " input:checked").length + ")";
            }
          }
        }
        $(".open-filter[data-filter='" + type + "'] .counter").html(counter);
        reloadBlogGrid();
      });

      // Blog Filter
      $("#filter_blog #filter_search").on("keyup", function search(e) {
        clearTimeout(blogTypingTimer);
        if (e.keyCode == 13) {
          e.preventDefault();
          reloadBlogGrid();
        } else {
          blogTypingTimer = setTimeout(reloadBlogGrid, doneTypingInterval);
        }
      });

      // Blog Filter
      $("#filter_blog .filter-search button").on("click", function (e) {
        e.preventDefault();
        $('#kategorie_all ').removeClass('active');
        reloadBlogGrid();
      });
      $("#filter_blog .list_item_cat").on("click", function (e) {
        $(this).toggleClass('active');
        $('#kategorie_all ').removeClass('active');
        $('#kategorie').prop('checked', false);
        e.preventDefault();
        reloadBlogGrid();
      });
      $("#kategorie_all").on("click", function (e) {
        $(this).toggleClass('active');
        $('.post-type-archive-blog .filter-wrapper-content input[type="radio"]').prop('checked', false);
        $('.list_item_cat ').removeClass('active');
        e.preventDefault();
        reloadBlogGrid();
      });

      //podcast events
      // Podcast Filter
      $('#filter_podcast input[type="checkbox"]').on('change', function () {
        var $this = $(this);
        var val = $this.val();
        var type = $this.attr('data-type');
        var counter = "";

        //console.log(val)

        // // ALL SELECTED
        if (val === "") {
          $('#filter_podcast .filter-' + type + ' input[type="checkbox"]').not($this).each(function () {
            $(this).prop("checked", false);
          });
          $($this).prop("checked", true);
        } else {
          if ($this.prop("checked") === true) {
            $('#' + type).prop("checked", false);
            counter = "(" + $(".filter-" + type + " input:checked").length + ")";
          } else {
            var allchecked = true;
            $('#filter_podcast .filter-' + type + ' input[type="checkbox"]').not($('#' + type)).each(function () {
              if ($(this).prop("checked")) {
                allchecked = false;
              }
            });
            if (allchecked) {
              $('#' + type).prop("checked", true);
            } else {
              counter = "(" + $(".filter-" + type + " input:checked").length + ")";
            }
          }
        }
        $(".open-filter[data-filter='" + type + "'] .counter").html(counter);
        reloadPodcastGrid();
      });

      // Podcast Filter
      $("#filter_podcast #filter_search").on("keyup", function search(e) {
        clearTimeout(podcastTypingTimer);
        if (e.keyCode == 13) {
          e.preventDefault();
          reloadPodcastGrid();
        } else {
          podcastTypingTimer = setTimeout(reloadPodcastGrid, doneTypingInterval);
        }
      });

      // Podcast Filter
      $("#filter_podcast .filter-search button").on("click", function (e) {
        e.preventDefault();
        reloadPodcastGrid();
      });

      // Load more handlers
      $('#load-more-news').on('click', function () {
        reloadNewsGrid();
      });

      // Handle "Load More" Button Klick
      $('#load-more-posts').on('click', function () {
        loadMorePosts();
      });
      $('#load-more-blog-posts').on('click', function () {
        loadMoreBlogPosts();
      });

      // Additional filter UI
      $("#filter_blog #filter_search").keypress(function (e) {
        $('#search-go').css('display', 'none');
        $('#team-rest').css('display', 'block');
      });
      $("#team-rest").button().click(function () {
        $('input[name=filter_search]').val('');
        window.location.href = window.location.href.split("?")[0];
      });
      var $myGroup = jQuery('#myGroup');
      $myGroup.on('show', '.collapse', function () {
        $myGroup.find('.collapse.in').collapse('hide');
      });
    }

    function _typeof(o) {
      "@babel/helpers - typeof";

      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
        return typeof o;
      } : function (o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, _typeof(o);
    }

    /**
     * Initializes download selection and collection functionality
     */
    function initDownloads() {
      // Handle download selection on archive pages
      $(document).on("change", ".post-type-archive-downloads .selection-check", function () {
        var curr_counter = parseInt($(".download-selection .selection-counter").html());
        if ($(this).prop("checked")) {
          curr_counter = curr_counter + 1;
        } else {
          curr_counter = curr_counter - 1;
          reloadDownloadsGrid();
        }

        // Update counter display and button state
        $(".download-selection .selection-counter").html(curr_counter);
        if (curr_counter > 0) {
          $(".download-selection").removeClass("disabled");
        } else {
          $(".download-selection").addClass("disabled");
        }
      });

      // Handle download selection in content modules (not on archive pages)
      $(document).on("change", "body:not(.post-type-archive-downloads) .selection-check", function () {
        var collectionID = $(this).attr('data-blockid');
        var curr_counter = parseInt($("#" + collectionID + " .download-selection .selection-counter").html());
        if ($(this).prop("checked")) {
          curr_counter = curr_counter + 1;
        } else {
          curr_counter = curr_counter - 1;
        }

        // Update counter display and button state for specific collection
        $("#" + collectionID + " .download-selection .selection-counter").html(curr_counter);
        if (curr_counter > 0) {
          $("#" + collectionID + " .download-selection").removeClass("disabled");
        } else {
          $("#" + collectionID + " .download-selection").addClass("disabled");
        }
      });

      // Select all downloads in a collection
      $(document).on("click", ".download-all", function () {
        var collectionID = $(this).attr('data-collection');
        var $this = $(this);

        // Reset counter and check all items
        $("#" + collectionID + " .download-selection .selection-counter").html("0");
        $("#" + collectionID + " .downloads-tiles .selection-check").each(function () {
          $(this).prop('checked', true).change();
        });

        // Auto-trigger download if no modal is required
        var has_modal = $this.attr('data-toggle');
        if (_typeof(has_modal) === ("undefined" ) || has_modal === false) {
          $this.siblings(".download-selection").click();
        }
      });

      // Handle single file download with consent modal
      $(document).on('click', '.modal .formular .consent-download', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var file = $(this).attr('data-url');

        // Only download if consent checkbox is checked
        if (form.find('#consent').prop("checked")) {
          window.open(file, '_blank').focus();
        }
      });

      // Handle collection download with consent modal
      $(document).on('click', '.modal .formular .consent-download-selection', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var selection = $(this).attr('data-selection');
        var selectionURL = "/dlc-collection.php?dlids=";

        // Only download if consent checkbox is checked
        if (form.find('#consent').prop("checked")) {
          // Build URL with all selected download IDs
          $("#" + selection + " .selection-check:checked").each(function () {
            selectionURL += $(this).val() + ",";
          });
          selectionURL = selectionURL.slice(0, -1); // Remove trailing comma
          window.open(selectionURL, '_blank').focus();
        }
      });

      // Direct download for single file (without modal)
      $(document).on('click', '.dlc01 .tsrbutton:not([data-toggle="modal"])', function (e) {
        e.preventDefault();
        var file = "/dlc-collection.php?dlids=" + $(this).attr('data-file');
        window.open(file, '_blank').focus();
      });

      // Direct download for collection (without modal)
      $(document).on('click', '.dlc02 .download-selection:not([data-toggle="modal"])', function (e) {
        e.preventDefault();
        var selection = $(this).attr('data-selection');
        var selectionURL = "/dlc-collection.php?dlids=";

        // Build URL with all selected download IDs
        $("#" + selection + " .selection-check:checked").each(function () {
          selectionURL += $(this).val() + ",";
        });
        selectionURL = selectionURL.slice(0, -1); // Remove trailing comma
        window.open(selectionURL, '_blank').focus();
      });
    }

    /**
     * Initializes accordion components
     * Supports two accordion types: checkbox-based (acn01) and toggle-based (acn02)
     */
    function initAccordion() {
      // Checkbox-based accordion (simple expand/collapse)
      $("body").on("change", ".acn01 .acn-tab input[type='checkbox']", function () {
        if ($(this).prop("checked")) {
          // Expand content with calculated height
          $(this).siblings(".acn-tab-content").css("max-height", $(this).siblings(".acn-tab-content").children(".row").innerHeight() + 60 + "px");
        } else {
          // Collapse content
          $(this).siblings(".acn-tab-content").css("max-height", "0");
        }
        ScrollReveal().sync();
      });

      // Toggle-based accordion with animated transitions
      $("body").on("click", ".acn02 .acn-tab-toggler .switch", function () {
        var $tab = $(this).closest(".acn-tabs").find(".acn-tab");
        var $this = $(this);
        if ($tab.hasClass("collapsed")) {
          // Expand animation sequence
          $tab.children(".acn-tab-content").css("min-height", $tab.find(".collapsed").children(".inner").innerHeight() + "px");
          $tab.find(".collapsed").css("opacity", "0").css("max-height", "0");
          setTimeout(function () {
            $this.addClass("expanded");
            $tab.removeClass("collapsed").addClass("expanded");
            $tab.find(".expanded").css("max-height", $tab.find(".expanded").children(".inner").innerHeight() + "px").css("opacity", "1");
            $tab.children(".acn-tab-content").css("min-height", $tab.find(".expanded").children(".inner").innerHeight() + "px");
            setTimeout(function () {
              $tab.find(".expanded").css("max-height", "unset").css("opacity", "1");
            }, 500);
          }, 500);
        } else {
          // Collapse animation sequence
          $tab.children(".acn-tab-content").css("min-height", $tab.find(".expanded").children(".inner").innerHeight() + "px");
          $tab.find(".expanded").css("opacity", "0").css("max-height", "0");
          setTimeout(function () {
            $this.removeClass("expanded");
            $tab.removeClass("expanded").addClass("collapsed");
            $tab.find(".collapsed").css("max-height", $tab.find(".collapsed").children(".inner").innerHeight() + "px").css("opacity", "1");
            $tab.children(".acn-tab-content").css("min-height", $tab.find(".collapsed").children(".inner").innerHeight() + "px");
            setTimeout(function () {
              $tab.find(".collapsed").css("max-height", "unset").css("opacity", "1");
            }, 500);
          }, 500);
        }
        ScrollReveal().sync();
      });
    }

    /**
     * Initializes Bootstrap carousel components
     */
    function initCarousel() {
      $('.carousel').carousel();
    }

    function getDefaultExportFromCjs (x) {
    	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }

    var lazyload_min$1 = {exports: {}};

    var lazyload_min = lazyload_min$1.exports;

    var hasRequiredLazyload_min;

    function requireLazyload_min () {
    	if (hasRequiredLazyload_min) return lazyload_min$1.exports;
    	hasRequiredLazyload_min = 1;
    	(function (module, exports) {
    		!function(e,t){module.exports=t();}(lazyload_min,(function(){const e="undefined"!=typeof window,t=e&&!("onscroll"in window)||"undefined"!=typeof navigator&&/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),a=e&&window.devicePixelRatio>1,n={elements_selector:".lazy",container:t||e?document:null,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",data_bg_hidpi:"bg-hidpi",data_bg_multi:"bg-multi",data_bg_multi_hidpi:"bg-multi-hidpi",data_bg_set:"bg-set",data_poster:"poster",class_applied:"applied",class_loading:"loading",class_loaded:"loaded",class_error:"error",class_entered:"entered",class_exited:"exited",unobserve_completed:true,unobserve_entered:false,cancel_on_exit:true,callback_enter:null,callback_exit:null,callback_applied:null,callback_loading:null,callback_loaded:null,callback_error:null,callback_finish:null,callback_cancel:null,use_native:false,restore_on_error:false},s=e=>Object.assign({},n,e),l=function(e,t){let a;const n="LazyLoad::Initialized",s=new e(t);try{a=new CustomEvent(n,{detail:{instance:s}});}catch(e){a=document.createEvent("CustomEvent"),a.initCustomEvent(n,false,false,{instance:s});}window.dispatchEvent(a);},o="src",r="srcset",i="sizes",d="poster",c="llOriginalAttrs",_="data",u="loading",g="loaded",b="applied",h="error",m="native",p="data-",f="ll-status",v=(e,t)=>e.getAttribute(p+t),E=e=>v(e,f),I=(e,t)=>((e,t,a)=>{const n=p+t;null!==a?e.setAttribute(n,a):e.removeAttribute(n);})(e,f,t),y=e=>I(e,null),k=e=>null===E(e),A=e=>E(e)===m,L=[u,g,b,h],w=(e,t,a,n)=>{e&&"function"==typeof e&&(void 0===n?void 0===a?e(t):e(t,a):e(t,a,n));},x=(t,a)=>{e&&""!==a&&t.classList.add(a);},C=(t,a)=>{e&&""!==a&&t.classList.remove(a);},O=e=>e.llTempImage,M=(e,t)=>{if(!t)return;const a=t._observer;a&&a.unobserve(e);},z=(e,t)=>{e&&(e.loadingCount+=t);},N=(e,t)=>{e&&(e.toLoadCount=t);},T=e=>{let t=[];for(let a,n=0;a=e.children[n];n+=1)"SOURCE"===a.tagName&&t.push(a);return t},R=(e,t)=>{const a=e.parentNode;a&&"PICTURE"===a.tagName&&T(a).forEach(t);},G=(e,t)=>{T(e).forEach(t);},D=[o],H=[o,d],V=[o,r,i],F=[_],j=e=>!!e[c],B=e=>e[c],J=e=>delete e[c],S=(e,t)=>{if(j(e))return;const a={};t.forEach((t=>{a[t]=e.getAttribute(t);})),e[c]=a;},P=(e,t)=>{if(!j(e))return;const a=B(e);t.forEach((t=>{((e,t,a)=>{a?e.setAttribute(t,a):e.removeAttribute(t);})(e,t,a[t]);}));},U=(e,t,a)=>{x(e,t.class_applied),I(e,b),a&&(t.unobserve_completed&&M(e,t),w(t.callback_applied,e,a));},$=(e,t,a)=>{x(e,t.class_loading),I(e,u),a&&(z(a,1),w(t.callback_loading,e,a));},q=(e,t,a)=>{a&&e.setAttribute(t,a);},K=(e,t)=>{q(e,i,v(e,t.data_sizes)),q(e,r,v(e,t.data_srcset)),q(e,o,v(e,t.data_src));},Q={IMG:(e,t)=>{R(e,(e=>{S(e,V),K(e,t);})),S(e,V),K(e,t);},IFRAME:(e,t)=>{S(e,D),q(e,o,v(e,t.data_src));},VIDEO:(e,t)=>{G(e,(e=>{S(e,D),q(e,o,v(e,t.data_src));})),S(e,H),q(e,d,v(e,t.data_poster)),q(e,o,v(e,t.data_src)),e.load();},OBJECT:(e,t)=>{S(e,F),q(e,_,v(e,t.data_src));}},W=["IMG","IFRAME","VIDEO","OBJECT"],X=(e,t)=>{!t||(e=>e.loadingCount>0)(t)||(e=>e.toLoadCount>0)(t)||w(e.callback_finish,t);},Y=(e,t,a)=>{e.addEventListener(t,a),e.llEvLisnrs[t]=a;},Z=(e,t,a)=>{e.removeEventListener(t,a);},ee=e=>!!e.llEvLisnrs,te=e=>{if(!ee(e))return;const t=e.llEvLisnrs;for(let a in t){const n=t[a];Z(e,a,n);}delete e.llEvLisnrs;},ae=(e,t,a)=>{(e=>{delete e.llTempImage;})(e),z(a,-1),(e=>{e&&(e.toLoadCount-=1);})(a),C(e,t.class_loading),t.unobserve_completed&&M(e,a);},ne=(e,t,a)=>{const n=O(e)||e;ee(n)||((e,t,a)=>{ee(e)||(e.llEvLisnrs={});const n="VIDEO"===e.tagName?"loadeddata":"load";Y(e,n,t),Y(e,"error",a);})(n,(s=>{((e,t,a,n)=>{const s=A(t);ae(t,a,n),x(t,a.class_loaded),I(t,g),w(a.callback_loaded,t,n),s||X(a,n);})(0,e,t,a),te(n);}),(s=>{((e,t,a,n)=>{const s=A(t);ae(t,a,n),x(t,a.class_error),I(t,h),w(a.callback_error,t,n),a.restore_on_error&&P(t,V),s||X(a,n);})(0,e,t,a),te(n);}));},se=(e,t,n)=>{(e=>W.indexOf(e.tagName)>-1)(e)?((e,t,a)=>{ne(e,t,a),((e,t,a)=>{const n=Q[e.tagName];n&&(n(e,t),$(e,t,a));})(e,t,a);})(e,t,n):((e,t,n)=>{(e=>{e.llTempImage=document.createElement("IMG");})(e),ne(e,t,n),(e=>{j(e)||(e[c]={backgroundImage:e.style.backgroundImage});})(e),((e,t,n)=>{const s=v(e,t.data_bg),l=v(e,t.data_bg_hidpi),r=a&&l?l:s;r&&(e.style.backgroundImage=`url("${r}")`,O(e).setAttribute(o,r),$(e,t,n));})(e,t,n),((e,t,n)=>{const s=v(e,t.data_bg_multi),l=v(e,t.data_bg_multi_hidpi),o=a&&l?l:s;o&&(e.style.backgroundImage=o,U(e,t,n));})(e,t,n),((e,t,a)=>{const n=v(e,t.data_bg_set);if(!n)return;let s=n.split("|").map((e=>`image-set(${e})`));e.style.backgroundImage=s.join(),U(e,t,a);})(e,t,n);})(e,t,n);},le=e=>{e.removeAttribute(o),e.removeAttribute(r),e.removeAttribute(i);},oe=e=>{R(e,(e=>{P(e,V);})),P(e,V);},re={IMG:oe,IFRAME:e=>{P(e,D);},VIDEO:e=>{G(e,(e=>{P(e,D);})),P(e,H),e.load();},OBJECT:e=>{P(e,F);}},ie=(e,t)=>{(e=>{const t=re[e.tagName];t?t(e):(e=>{if(!j(e))return;const t=B(e);e.style.backgroundImage=t.backgroundImage;})(e);})(e),((e,t)=>{k(e)||A(e)||(C(e,t.class_entered),C(e,t.class_exited),C(e,t.class_applied),C(e,t.class_loading),C(e,t.class_loaded),C(e,t.class_error));})(e,t),y(e),J(e);},de=["IMG","IFRAME","VIDEO"],ce=e=>e.use_native&&"loading"in HTMLImageElement.prototype,_e=(e,t,a)=>{e.forEach((e=>(e=>e.isIntersecting||e.intersectionRatio>0)(e)?((e,t,a,n)=>{const s=(e=>L.indexOf(E(e))>=0)(e);I(e,"entered"),x(e,a.class_entered),C(e,a.class_exited),((e,t,a)=>{t.unobserve_entered&&M(e,a);})(e,a,n),w(a.callback_enter,e,t,n),s||se(e,a,n);})(e.target,e,t,a):((e,t,a,n)=>{k(e)||(x(e,a.class_exited),((e,t,a,n)=>{a.cancel_on_exit&&(e=>E(e)===u)(e)&&"IMG"===e.tagName&&(te(e),(e=>{R(e,(e=>{le(e);})),le(e);})(e),oe(e),C(e,a.class_loading),z(n,-1),y(e),w(a.callback_cancel,e,t,n));})(e,t,a,n),w(a.callback_exit,e,t,n));})(e.target,e,t,a)));},ue=e=>Array.prototype.slice.call(e),ge=e=>e.container.querySelectorAll(e.elements_selector),be=e=>(e=>E(e)===h)(e),he=(e,t)=>(e=>ue(e).filter(k))(e||ge(t)),me=function(t,a){const n=s(t);this._settings=n,this.loadingCount=0,((e,t)=>{ce(e)||(t._observer=new IntersectionObserver((a=>{_e(a,e,t);}),(e=>({root:e.container===document?null:e.container,rootMargin:e.thresholds||e.threshold+"px"}))(e)));})(n,this),((t,a)=>{e&&(a._onlineHandler=()=>{((e,t)=>{var a;(a=ge(e),ue(a).filter(be)).forEach((t=>{C(t,e.class_error),y(t);})),t.update();})(t,a);},window.addEventListener("online",a._onlineHandler));})(n,this),this.update(a);};return me.prototype={update:function(e){const a=this._settings,n=he(e,a);var s,l;N(this,n.length),t?this.loadAll(n):ce(a)?((e,t,a)=>{e.forEach((e=>{ -1!==de.indexOf(e.tagName)&&((e,t,a)=>{e.setAttribute("loading","lazy"),ne(e,t,a),((e,t)=>{const a=Q[e.tagName];a&&a(e,t);})(e,t),I(e,m);})(e,t,a);})),N(a,0);})(n,a,this):(l=n,(e=>{e.disconnect();})(s=this._observer),((e,t)=>{t.forEach((t=>{e.observe(t);}));})(s,l));},destroy:function(){this._observer&&this._observer.disconnect(),e&&window.removeEventListener("online",this._onlineHandler),ge(this._settings).forEach((e=>{J(e);})),delete this._observer,delete this._settings,delete this._onlineHandler,delete this.loadingCount,delete this.toLoadCount;},loadAll:function(e){const t=this._settings;he(e,t).forEach((e=>{M(e,this),se(e,t,this);}));},restoreAll:function(){const e=this._settings;ge(e).forEach((t=>{ie(t,e);}));}},me.load=(e,t)=>{const a=s(t);se(e,a);},me.resetStatus=e=>{y(e);},e&&((e,t)=>{if(t)if(t.length)for(let a,n=0;a=t[n];n+=1)l(e,a);else l(e,t);})(me,window.lazyLoadOptions),me})); 
    	} (lazyload_min$1));
    	return lazyload_min$1.exports;
    }

    var lazyload_minExports = /*@__PURE__*/ requireLazyload_min();
    var LazyLoad = /*@__PURE__*/getDefaultExportFromCjs(lazyload_minExports);

    /**
     * Lazy Load Module
     * Wrapper for vanilla-lazyload library
     * Handles image/video lazy loading with smooth fade-in animation
     */

    function initLazyLoad() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$elementSelec = options.elementSelector,
        elementSelector = _options$elementSelec === void 0 ? '[data-src]' : _options$elementSelec,
        _options$loadedClass = options.loadedClass,
        loadedClass = _options$loadedClass === void 0 ? 'lazy-loaded' : _options$loadedClass,
        _options$loadingClass = options.loadingClass,
        loadingClass = _options$loadingClass === void 0 ? 'lazy-loading' : _options$loadingClass,
        _options$threshold = options.threshold,
        threshold = _options$threshold === void 0 ? 300 : _options$threshold;

      // Initialize vanilla-lazyload
      var lazyLoadInstance = new LazyLoad({
        elements_selector: elementSelector,
        class_loaded: loadedClass,
        class_loading: loadingClass,
        threshold: threshold,
        // Use callback to handle animation timing
        callback_loaded: function callback_loaded(element) {
          // Trigger fade-in animation
          element.classList.add(loadedClass);
        },
        callback_error: function callback_error(element) {
          // Still add loaded class so layout doesn't break
          element.classList.add(loadedClass);
        }
      });
      return lazyLoadInstance;
    }

    /**
     * Initializes EKKO Lightbox for image galleries
     */
    function initLightbox() {
      // Initialize lightbox on elements with data-toggle="lightbox"
      $(document).on('click', '[data-toggle="lightbox"]', function (event) {
        event.preventDefault();
        $(this).ekkoLightbox();
      });
    }

    /**
     * Initializes custom modal behaviors
     */
    function initModal() {
      // Custom close button for modals
      $(document).on('click', '.modal .customClose', function () {
        $(this).closest('.modal').modal('hide');
      });

      // Move modal to body element when shown (prevents z-index issues)
      $(document).on('show.bs.modal', '.modal-move-to-body', function (e) {
        $(e.relatedTarget.attributes['data-target'].value).appendTo('body');
      });
    }

    /**
     * Shows text items with a fade-in animation
     * Currently all items appear simultaneously (delay = 0)
     */
    function showTextItemsWithDelay() {
      var textItemsDisplay = document.querySelectorAll(".text-item-display");
      var delay = 0;
      textItemsDisplay.forEach(function (textItem) {
        textItem.classList.remove("d-none");
        setTimeout(function () {
          animateOpacity(textItem, 0, 1, 100);
          textItem.classList.remove("d-none");
        }, delay);
        delay += 0; // Currently no delay between items
      });
    }
    function animateOpacity(element, from, to, duration) {
      var start = null;
      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        var opacity = progress / duration;
        element.style.opacity = Math.min(opacity, 1);
        if (progress < duration) {
          window.requestAnimationFrame(step);
        }
      }
      window.requestAnimationFrame(step);
    }

    /**
     * Processes URL-based logic
     * Hides all <sub> elements on English language pages
     */
    function verarbeiteURL() {
      // Helper function to hide all subscript elements
      function ausblendenAlleSubElemente() {
        var subElemente = document.querySelectorAll('sub');
        if (subElemente.length > 0) {
          subElemente.forEach(function (subElement) {
            subElement.style.display = 'none';
          });
        }
      }

      // Check if current URL is English version
      var aktuelleURL = window.location.href;
      if (aktuelleURL.indexOf("/en/") !== -1) {
        console.log("Die URL enthält '/en/'!");
        // Hide subscript elements on English pages
        ausblendenAlleSubElemente();
      }
    }

    /**
     * Initializes global event listeners for window events
     */
    function initEventDelegation() {
      // Handle window resize and orientation changes
      $(window).on('resize orientationchange', function () {
        // Recalculate ScrollReveal animations
        ScrollReveal().sync();
        // Adjust carousel heights
        normalizeSlideHeights();
      });
    }

    /**
     * Applies alternating background classes to content sections
     * - supports multiple container wrappers
     * - skips spacer blocks (.spr01)
     * - ignores structural noise (empty <p>)
     */

    function initAlternatingSectionBackgrounds() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$containerSel = options.containerSelectors,
        containerSelectors = _options$containerSel === void 0 ? [".entry-content", ".content-area", ".post-content", ".page-content", ".wysiwyg"] : _options$containerSel,
        _options$skipSelector = options.skipSelector,
        skipSelector = _options$skipSelector === void 0 ? [".spr01", ".breadcrumb-nav"] : _options$skipSelector,
        _options$classA = options.classA,
        classA = _options$classA === void 0 ? "is-alt-a" : _options$classA,
        _options$classB = options.classB,
        classB = _options$classB === void 0 ? "is-alt-b" : _options$classB,
        _options$allowedTags = options.allowedTags,
        allowedTags = _options$allowedTags === void 0 ? ["DIV", "SECTION"] : _options$allowedTags;
      var containers = containerSelectors.flatMap(function (sel) {
        return Array.from(document.querySelectorAll(sel));
      });
      var uniqueContainers = Array.from(new Set(containers));
      uniqueContainers.forEach(function (container) {
        var index = 0;
        var previousClass = null;
        var applyPreviousClass = false;
        Array.from(container.children).forEach(function (el) {
          if (!(el instanceof HTMLElement)) return;

          // ignore empty or structural noise
          if (el.tagName === "P" && !el.textContent.trim()) return;

          // ignore spacer blocks
          if (el.matches(skipSelector)) return;

          // only count allowed elements
          if (!allowedTags.includes(el.tagName)) return;

          // make re-runnable
          el.classList.remove(classA, classB);
          var classToApply;

          // if previous element had section-combine, apply its class to this element
          if (applyPreviousClass) {
            classToApply = previousClass;
            applyPreviousClass = false;
            index++; // now increment after applying previous class
          } else {
            // normal alternation
            classToApply = index % 2 === 0 ? classA : classB;
            index++;
          }
          el.classList.add(classToApply);
          previousClass = classToApply;

          // if this element has section-combine, don't increment next time
          if (el.classList.contains('section-combine')) {
            applyPreviousClass = true;
            index--; // undo the increment we just did
          }
        });
      });
    }

    // utils.js

    function debounce(fn) {
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
      var timeoutId;
      return function () {
        var _this = this;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
          return fn.apply(_this, args);
        }, delay);
      };
    }

    // Width class thresholds (percentage of brand-header width)
    var WIDTH_THRESHOLDS = {
      narrow: 33,
      // < 33% = narrow
      medium: 42 // 33-42% = medium, > 42% = wide
    };
    function initTypoBlockOverflow() {
      var typoBlock = document.querySelector('.typo-block');
      if (!typoBlock) return;
      var brandHeaderText = document.querySelector('.brand-header__text');
      var brandHeader = document.querySelector('.brand-header');
      function calculateOverflow() {
        // Reset für saubere Messung
        typoBlock.style.setProperty('--overflow-left', '0px');
        typoBlock.style.setProperty('--overflow-right', '0px');

        // Reflow erzwingen – Browser muss Layout jetzt neu berechnen
        typoBlock.offsetHeight;
        var blockRect = typoBlock.getBoundingClientRect();
        var highlights = typoBlock.querySelectorAll('.typo-line__highlight span');
        var overflowLeft = 0;
        var overflowRight = 0;
        highlights.forEach(function (span) {
          var spanRect = span.getBoundingClientRect();
          var leftOverflow = blockRect.left - spanRect.left;
          if (leftOverflow > overflowLeft) {
            overflowLeft = leftOverflow;
          }
          var rightOverflow = spanRect.right - blockRect.right;
          if (rightOverflow > overflowRight) {
            overflowRight = rightOverflow;
          }
        });
        typoBlock.style.setProperty('--overflow-left', "".concat(overflowLeft, "px"));
        typoBlock.style.setProperty('--overflow-right', "".concat(overflowRight, "px"));

        // Calculate width class for brand-header__text
        applyWidthClass();
      }
      function applyWidthClass() {
        if (!brandHeaderText || !brandHeader) return;
        var textWidth = brandHeaderText.getBoundingClientRect().width;
        var headerWidth = brandHeader.getBoundingClientRect().width;
        if (headerWidth === 0) return;
        var widthPercentage = textWidth / headerWidth * 100;

        // Debug output
        /*console.log('--- Typo Width Debug ---');
        console.log('brand-header width:', Math.round(headerWidth) + 'px');
        console.log('brand-header__text width:', Math.round(textWidth) + 'px');
        console.log('Percentage:', widthPercentage.toFixed(1) + '%');*/

        // Remove existing width classes
        brandHeaderText.classList.remove('typo-width--narrow', 'typo-width--medium', 'typo-width--wide');
        if (widthPercentage < WIDTH_THRESHOLDS.narrow) {
          brandHeaderText.classList.add('typo-width--narrow');
        } else if (widthPercentage < WIDTH_THRESHOLDS.medium) {
          brandHeaderText.classList.add('typo-width--medium');
        } else {
          brandHeaderText.classList.add('typo-width--wide');
        }
        /*
        console.log('Applied class:', appliedClass);
        console.log('------------------------');
         */
      }
      calculateOverflow();
      requestAnimationFrame(function () {
        typoBlock.classList.add('is-visible');
      });
      window.addEventListener('resize', debounce(calculateOverflow, 100));
    }

    /**
     * Team Layout Module
     * Sets min-height of .team-content based on .team-subnav .subnav-contents height
     */

    function initTeamLayout() {
      var teamContent = document.querySelector('.team-content');
      var subnavContents = document.querySelector('.team-subnav .subnav-contents');

      // Only run if both elements exist
      if (!teamContent || !subnavContents) return;
      function setMinHeight() {
        var subnavHeight = subnavContents.getBoundingClientRect().height;

        // Debug output
        //console.log('--- Team Layout Debug ---');
        //console.log('subnav-contents height:', Math.round(subnavHeight) + 'px');
        //console.log('-------------------------');

        teamContent.style.minHeight = "".concat(subnavHeight, "px");
      }

      // Initial calculation
      setMinHeight();

      // Recalculate on resize
      window.addEventListener('resize', debounce(setMinHeight, 100));
    }

    /**
     * Subnav Overflow Module
     * 1. Shows/hides .navpoints based on whether .contents has children (centralized logic).
     * 2. Prevents .subnav from overflowing past .header-intro into subsequent sections
     *    by adjusting min-height of .header-intro.
     * 3. Automatically adds navpoints--dark when the subnav extends below its parent
     *    section (desktop only), so it contrasts against the light background beneath.
     *
     * .navpoints is hidden by default via CSS (display: none) to prevent FOUC.
     * This module runs after a 500ms delay to ensure block JS has populated TOC links.
     */

    var BREAKPOINT_LG = 992;
    function initSubnavOverflow() {
      // Delay to ensure block JS (e.g. cmp06.js) has populated .contents with TOC links
      setTimeout(adjustAll, 500);
      window.addEventListener('resize', debounce(adjustAll, 150));
    }
    function adjustAll() {
      showNavpointsWithContent();
      adjustHeaderIntroMinHeight();
      applyDarkNavpoints();
    }

    // Shows .navpoints with fade-in when .contents has children
    function showNavpointsWithContent() {
      document.querySelectorAll('.subnav .navpoints').forEach(function (navpoints) {
        var contents = navpoints.querySelector('.contents');
        if (contents && contents.children.length > 0) {
          navpoints.style.display = 'block';
          // Trigger opacity transition on next frame
          requestAnimationFrame(function () {
            navpoints.style.opacity = '1';
          });
        }
      });
    }

    // Sets min-height on .header-intro when subnav overflows beyond it
    function adjustHeaderIntroMinHeight() {
      var blocks = document.querySelectorAll('.header-intro-text');
      blocks.forEach(function (block) {
        var subnav = block.querySelector('.subnav');
        if (!subnav) return;

        // Find the next sibling .header-intro section
        var headerIntro = block.nextElementSibling;
        if (!headerIntro || !headerIntro.classList.contains('header-intro')) return;

        // Reset before measuring
        headerIntro.style.minHeight = '';
        var subnavBottom = subnav.getBoundingClientRect().bottom;
        var headerIntroBottom = headerIntro.getBoundingClientRect().bottom;

        // If subnav extends below .header-intro, increase its min-height
        if (subnavBottom > headerIntroBottom) {
          var overflow = subnavBottom - headerIntroBottom;
          var currentHeight = headerIntro.getBoundingClientRect().height;
          headerIntro.style.minHeight = "".concat(currentHeight + overflow + 40, "px");
        }
      });
    }

    // Adds navpoints--dark when subnav overflows past the entire header area (desktop only).
    // The header area = block wrapper div + .header-intro (if present).
    function applyDarkNavpoints() {
      if (window.innerWidth < BREAKPOINT_LG) return;
      document.querySelectorAll('.subnav').forEach(function (subnav) {
        var navpoints = subnav.querySelector('.navpoints');
        if (!navpoints) return;
        var parentSection = subnav.closest('section');
        if (!parentSection) return;

        // Block wrapper is the parent of the section (e.g. .cmp06, .cmp07)
        var blockWrapper = parentSection.parentElement;
        if (!blockWrapper) return;

        // As soon as subnav extends below the block wrapper, it's on a light background
        var areaBottom = blockWrapper.getBoundingClientRect().bottom;
        var subnavBottom = subnav.getBoundingClientRect().bottom;
        if (subnavBottom > areaBottom) {
          navpoints.classList.add('navpoints--dark');
        } else {
          navpoints.classList.remove('navpoints--dark');
        }
      });
    }

    /**
     * Main entry point for ARQIS theme JavaScript
     * Initializes all modules and components
     */

    $(document).ready(function () {
      // Handle publication link visibility
      var publikationenV1 = document.querySelector('.link-publikationen-v2');
      if (publikationenV1) {
        var publikationenV1El = publikationenV1.querySelector('li');
        if (!publikationenV1El) {
          var linkPublikationenV1None = document.querySelector('.link-publikationen-v1-none');
          linkPublikationenV1None.style.display = 'none';
        }
      } else {
        var linkPublikationenV1None = document.querySelector('.link-publikationen-v1-none');
        if (linkPublikationenV1None) {
          linkPublikationenV1None.style.display = 'none';
        }
      }

      // Fix career navigation label
      setTimeout(function () {
        var overlayDiv = document.querySelector('#nav_career');
        console.log(overlayDiv);
        if (overlayDiv) {
          var aTagInsideOverlay = overlayDiv.querySelector('.main-nav-overlay-content-subtitle');
          console.log(aTagInsideOverlay);
          if (aTagInsideOverlay && aTagInsideOverlay.textContent.trim().toLowerCase() === "contact") {
            aTagInsideOverlay.textContent = "CAREER AT ARQIS";
          }
        }
      }, 1000);

      // Process URL-based logic
      verarbeiteURL();

      // Truncate archive text items
      nkTruncateTextItemArchive();

      // Truncate search result text items
      var searchItems = document.querySelectorAll(".text-item-search");
      searchItems.forEach(function (textItem, index) {
        var text = textItem.textContent;
        if (text.length > nkTruncateMaxLength) {
          var truncatedText = text.substring(0, nkTruncateMaxLength) + '...';
          textItem.textContent = truncatedText;
        }
      });

      // Show text items with fade-in animation
      setTimeout(showTextItemsWithDelay(), 1000);

      // Remove ScrollReveal from WordPress block columns
      if ($('.wp-block-columns').length > 0) {
        $('.wp-block-column').each(function () {
          $(this).find('.scrollreveal').removeClass('scrollreveal');
        });
      }

      // Initialize ScrollReveal animations
      ScrollReveal({
        duration: 800,
        reset: false
      });
      ScrollReveal().reveal('.scrollreveal');

      // Sync ScrollReveal when job tiles load
      $(document).on("load", ".stellenangebote-tiles", function () {
        ScrollReveal().sync();
      });

      // Initialize all modules
      initAlternatingSectionBackgrounds();
      initNavigation();
      initSearch();
      initBaseFilter();
      initFilters();
      initDownloads();
      initAccordion();
      initCarousel();
      initLazyLoad();
      initLightbox();
      initModal();
      //initChatbot();
      initEventDelegation();
      initTypoBlockOverflow();
      initTeamLayout();
      initSubnavOverflow();
    });

})();
